import React from "react";
const autobind = require("class-autobind").default;
import { FormGroup } from "../../form/group/index";
import { Input } from "../../form/input/index";
import { InputBox } from "../../form/input.box/index";
import { Button } from "../../button/index";
import { FaBars, FaTrashAlt } from "react-icons/fa";
import { Tooltip } from "../../tooltip/index";
import { arrayMove, SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";
const DragHandle = SortableHandle(() => {
    return (React.createElement(InputBox, { className: "no-round width40 flex-center cursor-move" },
        React.createElement("p", { className: "big font-bold" },
            React.createElement(FaBars, null))));
});
const SortableItem = SortableElement((props) => {
    const { item, itemIndex, change, remove } = props;
    return (React.createElement("div", { key: itemIndex, className: "flex-line", style: { alignItems: "flex-end" } },
        React.createElement(DragHandle, null),
        React.createElement(InputBox, { className: "no-round width64 text-center" },
            React.createElement("p", { className: "big font-bold", style: { lineHeight: "36px" } }, itemIndex + 1)),
        React.createElement("div", { className: "flex-line flex-grow", style: { alignItems: "flex-end" } },
            React.createElement(FormGroup, { className: "m-b-0 flex-grow", small_title: true, no_border: true },
                React.createElement(Input, { type: "text", className: "no-round", value: item.name, placeholder: "Name", required: true, onChange: (e) => change(itemIndex, "name", e.target.value) }))),
        React.createElement(Tooltip, { text: "Delete", width: 65, position: "top", disable: itemIndex !== 0 },
            React.createElement(Button, { type: "button", className: "no-round", paddinglr: 5, color: "white", onClick: () => remove(itemIndex) },
                React.createElement(FaTrashAlt, null)))));
});
const SortableItemContainer = SortableContainer((props) => {
    return (React.createElement("div", null, props.items.map((item, i) => (React.createElement(SortableItem, { key: `item-${i}`, index: i, item: item, itemIndex: i, change: props.change, remove: props.remove })))));
});
export class FieldDishIngredients extends React.Component {
    constructor(props) {
        super(props);
        autobind(this);
    }
    remove = (i) => {
        const values = ([...this.props.values]);
        values.splice(i, 1);
        this.props.onChange(values);
    };
    change = (i, key, value) => {
        const values = [...this.props.values];
        values[i][key] = value;
        this.props.onChange(values);
    };
    setDefault = (i, quantity) => {
        this.props.onChange(this.props.values.map((item, index) => ({
            ...item,
            quantity: i === index ? quantity : 0,
        })));
    };
    onSortEnd = ({ oldIndex, newIndex }) => {
        const { onChange, values } = this.props;
        onChange(arrayMove(values, oldIndex, newIndex));
    };
    render() {
        const { values } = this.props;
        return (React.createElement(SortableItemContainer, { helperClass: "zindex-15 bsl-2", pressDelay: 50, useDragHandle: true, items: values, change: this.change, remove: this.remove, onSortEnd: this.onSortEnd }));
    }
}
//# sourceMappingURL=index.js.map